import { Pagination, PaginationProps, styled } from '@mui/material';
import React from 'react';

const StyledPagination = styled(Pagination)(({ theme }) => ({
  button: {
    color: theme.palette.neutral[400],
    borderRadius: '0.5rem',
  },
  '& .Mui-selected': {
    backgroundColor: theme.palette.green[200],
    color: theme.palette.green[800],
  },
}));

type PaginationV2Props = PaginationProps;

export const PaginationV2: React.FC<PaginationV2Props> = (props) => <StyledPagination {...props} />;
